import styled from 'styled-components';

export const StyledCategory = styled.div`
  .category {
    display: block;
    width: fit-content;
    background-color: var(--colors-white);
    padding: 0.4rem 1.75rem;
    font-weight: 600;

    &--pill {
      border-radius: 10rem;
      -webkit-appearance: none;
      -webkit-box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.32);
      -moz-box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.32);
      box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.32);
    }
  }
`;
